import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { CommitmentMechanics } from './CommitmentMechanics';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useCreditAgreementStore } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';

const RouteParamsStruct = z.object({
  commitmentId: z.string({ message: 'Missing commitmentId' }),
});

export const RouteBase = () => {
  const isCreditAgreementLoaded = useCreditAgreementStore((store) =>
    Boolean(store.creditAgreement),
  );

  const params = useParams();
  const { commitmentId } = RouteParamsStruct.parse(params);

  return (
    <Skeleton isLoaded={isCreditAgreementLoaded}>
      {isCreditAgreementLoaded && (
        // Need to provide a key here to reset the component whenever commitmentId changes.
        // This resets the react-hook-form state, and also the underlying AutoSave component.
        <CommitmentMechanics commitmentId={commitmentId} key={commitmentId} />
      )}
    </Skeleton>
  );
};

export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="../commitments" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
